const allergy=[
   {
       test:'ALLERGEN - ACACIA (ACACIA LONGIFOLIA)', 
    },
    {
        test:'ALLERGEN - ALTERNARIA ALTERNATA', 
     },







     {
        test:'ALLERGEN - APPLE (MALUS DOMESTICA)', 
     },
     {
        test:'ALLERGEN - ASPERGILLUS SPECIES', 
     },
     {
        test:'ALLERGEN - BANANA (MUSA SPP.)', 
     },
     {
        test:'ALLERGEN - BERMUDA GRASS (CYNODON DACTYLON) ', 
     },
     {
        test:' ALLERGEN - BLUE MUSSEL (MYTILUS EDULIS)', 
     },
     {
        test:'ALLERGEN - CABBAGE (PATTA GOBHI) (BRASSICA OLERACEA VAR. CAPITATA)', 
     },
     {
        test:'ALLERGEN - CASHEW NUT (ANACARDIUM OCCIDENTALE)', 
     },
     {
        test:'ALLERGEN - CAULIFLOWER (BRASSICA OLERACEA VAR.BOTRYTIS)', 
     },
     {
        test:'ALLERGEN - CHICK PEA (BENGAL GRAM) (CICER ARIETINUS)', 
     },
     {
        test:'ALLERGEN - CLADOSPORIUM HERBARUM', 
     },
     {
        test:'ALLERGEN - COFFEE (COFFEA SPP)', 
     },
     {
        test:'ALLERGEN - COMMON SILVER BIRCH (BETULA VERRUCOSA)', 
     },
     {
        test:'ALLERGEN - CULTIVATED RYE (SECALE CEREALE)', 
     },
     {
        test:'ALLERGEN - DRUG ACTH (ADRENOCORTICOTROPHIC HORMONE)', 
     },
     {
        test:'ALLERGEN - DRUG CEPHALOSPORIN', 
     },
     {
        test:'  ALLERGEN - DRUG GENTAMICIN', 
     },
     {
        test:'ALLERGEN - DRUG METRONIDZOLE', 
     },
     {
        test:'ALLERGEN - DRUG PENICILLOYAL G (ANTIBIOTIC)', 
     },
     {
        test:'ALLERGEN - DRUG STREPTOMYCIN', 
     },
     {
        test:'ALLERGEN - EGG YOLK', 
     },
     {
        test:'ALLERGEN - FISH (COD) (GADUS MORHUA)', 
     },
     {
        test:'ALLERGEN - GRAPE (VITIS VINIFERA)', 
     },
     {
        test:'ALLERGEN - HONEY BEE VENOM (APIS MELLIFERA)', 
     },
     {
        test:'ALLERGEN - HOUSE DUST MITE (DERMATOPHAGOIDES PTERONYSSINUS)', 
     },
     {
        test:'ALLERGEN - KIWI (ACTINIDIA DELICIOSA)', 
     },
     {
        test:'ALLERGEN - LENTIL (MASOOR) (LENS ESCULENTA)', 
     },
     {
        test:'ALLERGEN - MAIZE,CORN (ZEA MAYS)', 
     },
     {
        test:'ALLERGEN - MESQUITE (PROSOPIS JULIFLORA)', 
     },
     {
        test:'ALLERGEN - MUSHROOM (CHAMPIGNON)', 
     },
     {
        test:'ALLERGEN - OAK (QUERCUS ALBA)', 
     },
     {
        test:'ALLERGEN - ORANGE (CITRUS SINENSIS)', 
     },
     {
        test:'ALLERGEN - PARIETARIA JUDAICA; CLOSE TO HOLOPTELEA INTEGRIFOLIA (PAPRI)', 
     },
     {
        test:'ALLERGEN - PENICILLIUM CHRYSOGENUM', 
     },
     {
        test:'ALLERGEN - PIGEON SERUM PROTEINS FEATHERS AND DROPPINGS GE91', 
     },
     {
        test:'ALLERGEN - PORK', 
     },
     {
        test:'ALLERGEN - RABBIT EPITHELIUM', 
     },
     {
        test:'ALLERGEN - RICE (CHAWAL) (ORYZA SATIVA)', 
     },
     {
        test:'ALLERGEN - SESAME SEED (SESAMUM INDICUM)', 
     },
     {
        test:'ALLERGEN - SOYBEAN (GLYCINE MAX)', 
     },
     {
        test:'ALLERGEN - SWEET VERNAL GRASS (ANTHOXANTHUM ODORATUM)', 
     },
     {
        test:'ALLERGEN - TRICHOPHYTON MENT.VAR GOETZII', 
     },
     {
        test:'ALLERGEN - VELVET GRASS (HOLCUS LANATUS)', 
     },
     {
        test:'ALLERGEN - YEAST (SACCHAROMYCES CEREVISIAE)', 
     },
     {
        test:`ALLERGY PANEL DRUGS - 32 DRUGS (SPECIFIC IGE TEST) [IN-VITRO ALLERGY TEST]
FOOD INTOLERANCE TEST (O.S)`, 
     },
     {
        test:'ALLERGEN - DRUG AZITHROMYCIN', 
     },
     {
        test:'ALLERGEN - DRUG IBUPROFEN', 
     },
     {
        test:'ALLERGEN - DRUG RIFAMPICIN', 
     },
     {
        test:`ALLERGY PANEL ABPA (ALLERGIC BRONCHOPULMONARY ASPERGILLOSIS) [IN-VITRO ALLERGY TEST]`, 
     },
     {
        test:'ALLERGY PANEL CENTRAL INDIA REGION - 21 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL EAST INDIA REGION - 18 ALLERGENS', 
     },
     {
        test:' ALLERGY PANEL INHALANT - 18 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL NON VEGETARIAN FOOD PANEL COMPREHENSIVE - 27 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL RHINITIS/ASTHMA- COMPREHENSIVE -21 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL VEGETARIAN FOOD PANEL BASIC - 10 ALLERGENS', 
     },
     {
        test:'ALLERGEN - ALMOND', 
     },
     {
        test:'ALLERGEN - AMARANTHUS RETROFLEXUS (COMMON PIGWEED)', 
     },
     {
        test:'ALLERGEN - ASPERGILLUS FUMIGATUS', 
     },
     {
        test:'ALLERGEN - AUBERGINE, EGGPLANT (SOLANUM MELONGENA)', 
     },
     {
        test:'ALLERGEN - BARLEY (HORDEUM VULGARE)', 
     },
     {
        test:'ALLERGEN - BETA LACTOGLOBULIN', 
     },
     {
        test:'ALLERGEN - BOILED MILK (BOS SPP)', 
     },
     {
        test:'ALLERGEN - CARROT (DAUCUS CAROTA)', 
     },
     {
        test:'ALLERGEN - CASTOR BEAN (RICINUS COMMUNIS)', 
     },
     {
        test:'ALLERGEN - CELERY (APIUM GRAVEOLENS)', 
     },
     {
        test:'ALLERGEN - CHICKEN', 
     },
     {
        test:'ALLERGEN - COCKROACH (BLATELLA GERMANICA)', 
     },
     {
        test:'ALLERGEN - COMMON PIGWEED (AMARANTHUS RETROFLEXUS', 
     },
     {
        test:'ALLERGEN - COW DANDER', 
     },
     {
        test:'ALLERGEN - DOG DANDER', 
     },
     {
        test:'ALLERGEN - DRUG AMOXICILLOYL (AMOXICILLIN) (ANTIBIOTIC)', 
     },
     {
        test:'ALLERGEN - DRUG CEPHALOSPORIN', 
     },
     {
        test:'ALLERGEN - DRUG INSULIN HUMAN', 
     },
     {
        test:'ALLERGEN - DRUG NORFLOXACIN', 
     },
     {
        test:'ALLERGEN - DRUG PENICILLOYAL V (ANTIBIOTIC)', 
     },
     {
        test:'ALLERGEN - EGG', 
     },
     {
        test:'ALLERGEN - ELM (ULMUS AMERICANA) TREE POLLEN', 
     },
     {
        test:'ALLERGEN - GARLIC (ALLIUM SATIVUM)', 
     },
     {
        test:'ALLERGEN - GREY ALDER (ALNUS INCANA)', 
     },
     {
        test:'ALLERGEN - HORSE DANDER', 
     },
     {
        test:'ALLERGEN - JOHNSON GRASS (SORGHUM HALEPENSE)', 
     },
     {
        test:' ALLERGEN - LATEX (HEVEA BRASILIENSIS)', 
     },
     {
        test:'ALLERGEN - LETTUCE (LACTUCA SATIVA)', 
     },
     {
        test:'ALLERGEN - MANGO (MANGIFERA INDICA)', 
     },
     {
        test:'ALLERGEN - MOSQUITO (AEDES COMMUNIS)', 
     },
     {
        test:'ALLERGEN - MUSTARD ( BRASSICA SPP.)', 
     },
     {
        test:'ALLERGEN - OLEA EUROPAEA (OLIVE)', 
     },
     {
        test:'ALLERGEN - PAPAYA (CARICA PAPAYA)', 
     },
     {
        test:'ALLERGEN - PASPALUM NOTATUM', 
     },
     {
        test:'ALLERGEN - PHLEUM PRATENSE', 
     },
     {
        test:'ALLERGEN - PINEAPPLE (ANANAS COMOSUS)', 
     },
     {
        test:'ALLERGEN - POTATO (SOLANUM TUBEROSUM)', 
     },
     {
        test:'ALLERGEN - RAGWEED ALLERGEN COMPONENT NAMB A 1 RAGWEED', 
     },
     {
        test:'ALLERGEN - RYE (SECALE CEREALE)', 
     },
     {
        test:'ALLERGEN - SHRIMP', 
     },
     {
        test:'ALLERGEN - SPINACH (PALAK) (SPINACHIA OLERACEA)', 
     },
     {
        test:'ALLERGEN - TIMOTHY', 
     },
     {
        test:'ALLERGEN - TUNA (THUNNUS ALBACARES)', 
     },
     {
        test:'ALLERGEN - WHEAT (TRITICUM AESTIVUM)', 
     },
     {
        test:'ALLERGY PANEL CHILD - 15 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL ECZEMA/URTECARIA- BASIC- 15 ALLERGENS', 
     },
     {
        test:'ALLERGEN - CEFUROXIME DRUG', 
     },
     {
        test:'ALLERGEN - DRUG DICLOFENAC', 
     },
     {
        test:'ALLERGEN - DRUG INSULIN BOVINE', 
     },
   
   
   
   
     {
        test:'ALLERGEN - DRUG TETRACYCLINE', 
     },
     {
        test:'ALLERGY PANEL ADULT (COMPREHENSIVE) - 25 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL COMPREHENSIVE TOTAL - 40 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL ECZEMA/URTICARIA COMPREHENSIVE - 21 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL NORTH INDIA REGION - 21 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL SOUTH INDIA REGIONAL - 19 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL VEGETARIAN FOOD PANEL- COMPREHENSIVE - 20 ALLERGENS', 
     },
     {
        test:'ALLERGEN - APIS MELLIFERA (HONEY BEE)', 
     },
     {
        test:'ALLERGEN - ASPERGILLUS NIGAR', 
     },
     {
        test:'ALLERGEN - AVOCADO (PERSEA AMERICANA)', 
     },
     {
        test:'ALLERGEN - BEEF', 
     },
     {
        test:'ALLERGEN - BLACK PEPPER (PIPER NIGRUM)', 
     },
     {
        test:'ALLERGEN - BRAZIL NUT (BERTHOLLETIA EXCELSA)', 
     },
     {
        test:'ALLERGEN - CASEIN ALLERGEN COM-PONENT NBOS D 8 CASEIN', 
     },
     {
        test:'ALLERGEN - CAT DANDER', 
     },
     {
        test:'ALLERGEN - CHEESE, CHEDDAR TYPE', 
     },
     {
        test:'ALLERGEN - CIPROFLOXACIN DRUG', 
     },
     {
        test:'ALLERGEN - COCONUT (COCOS NUCIFERA)', 
     },
     {
        test:'ALLERGEN - COMMON RAGWEED (AMBROSIA ARTEMISIIFOLIA)', 
     },
     {
        test:'ALLERGEN - COWS MILK', 
     },
     {
        test:'ALLERGEN - DOOB GRASS (CYNODON DACTYLON)', 
     },
     {
        test:'ALLERGEN - DRUG AMPICILLOYL (AMPICILLIN) (ANTIBIOTIC)', 
     },
     {
        test:'ALLERGEN - DRUG DOXYCYCLINE', 
     },
     {
        test:'ALLERGEN - DRUG INSULIN PORCINE', 
     },
     {
        test:'ALLERGEN - DRUG PARACETAMOL', 
     },
     {
        test:'ALLERGEN - DRUG PYRAZOLONE', 
     },
     {
        test:'ALLERGEN - EGG WHITE', 
     },
     {
        test:'ALLERGEN - EUCALYPTUS, GUM-TREE (EUCALYPTUS SPP)', 
     },
     {
        test:'ALLERGEN - GLUTEN', 
     },
     {
        test:'ALLERGEN - HAZEL NUT (CORYLUS AVELLANA)', 
     },
     {
        test:'ALLERGEN - HOUSE DUST MITE (DERMATOPHAGOIDES FARINAE)', 
     },
     {
        test:'ALLERGEN - KENTUCKY BLUE (POA PRATENSIS)', 
     },

     {
        test:'ALLERGEN - LEMON (CITRUS LIMON)', 
     },
     {
        test:'ALLERGEN - LOLIUM PERENNE', 
     },
     {
        test:'ALLERGEN - MEADOW GRASS (POA PRATENSIS)', 
     },
     {
        test:'ALLERGEN - MULBERRY (MORUS ALBA)', 
     },
     {
        test:'ALLERGEN - MUTTON (OVIS SPP.)', 
     },
     {
        test:'ALLERGEN - ONION (ALLIUM CEPA)', 
     },
     {
        test:'ALLERGEN - PAPRIKA (SHIMLA MIRCH)(CAPSICUM ANNUUM)', 
     },
     {
        test:'ALLERGEN - PEANUT (MOONGFALI) (ARACHIS HYPOGAEA)', 
     },





     {
        test:'ALLERGEN - PIGEON DROPPINGS', 
     },
     {
        test:'ALLERGEN - PISTACHIO (PISTACIA VERA)', 
     },
     {
        test:'ALLERGEN - PROSOPIS JULIFLORA (VILAYATI BABUL)', 
     },
     {
        test:'ALLERGEN - RAPE SEED (BRASSICA NAPUS)', 
     },
     {
        test:'ALLERGEN - SALMON (SALMO SALAR)', 
     },
     {
        test:'ALLERGEN - SORGHUM HALEPENSE', 
     },

      {
        test:'ALLERGEN - SULPHA DRUG', 
     },
     {
        test:'ALLERGEN - TOMATO (LYCOPERSICON LYCOPERSICUM', 
     },
     {
        test:'ALLERGEN - TURKEY', 
     },

      {
        test:'ALLERGEN - WILD RYE GRASS (ELYMUS TRITICOIDES)', 
     },
     {
        test:'ALLERGY PANEL DRUGS - 11 DRUGS (SPECIFIC IGE TEST)', 
     },
     {
        test:'ALLERGY PANEL GASTROINTESTINAL TRACT (GIT) - 30 ALLERGENS', 
     },
     {
        test:'ALLERGEN - DRUG METRONIDAZOLE', 
     },


     {
        test:'ALLERGEN - DRUG DISPIRIN (ASPIRIN)', 
     },
     {
        test:'ALLERGEN - DRUG NIMESULIDE', 
     },
     {
        test:'ALLERGEN - DRUG XYLOCAINE', 
     },
     {
        test:'ALLERGY PANEL AVIAN ANTIGEN HYPERSENSITIVITY PNEUMONITIS PANEL - PIGEON + AF sIgG', 
     },
     {
        test:'ALLERGY PANEL DRUGS - 17 DRUGS (SPECIFIC IGE TEST) [IN-VITRO ALLERGY TEST]', 
     },
     {
        test:'ALLERGY PANEL HYPERSENSITIVITY PNEUMONITIS PANEL (HP PANEL) [SIGG IN-VITRO ALLERGY TEST]', 
     },
     {
        test:'ALLERGY PANEL NON VEG FOOD BASIC - 15 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL RHINITIS/ASTHMA- BASIC -15 AllERGEN', 
     },
     {
        test:'ALLERGY PANEL SPICES - 11 ALLERGENS', 
     },
     {
        test:'ALLERGY PANEL WHEEZE/RHINITIS BASIC - 25 ALLERGENS', 
     },

]


export default allergy;